import { CssBaseline, ThemeProvider } from "@mui/material";
import { useMemo } from "react";

import { useTheme } from "@/store/ui/theme.store";
import { createAppTheme } from ".";

export type AppThemeProps = {
  children: React.ReactNode;
};

const AppTheme: React.FC<AppThemeProps> = ({ children }) => {
  const mode = useTheme((s) => s.mode);
  const theme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default AppTheme;
